import { memo, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import CreateUi from "./CreateUi";
import { useDispatch, useSelector } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import {
  addUserApi,
  getUserByIdApi,
  // updateInstallerUserField,
  updateUserField,
} from "../../apis/user.api";
import { closeModal } from "../../store/actions/modalAction";
import { useParams } from "react-router-dom";
import { USER_ROLES } from "../../utils/constants";
import { findObjectKeyByValue, validatePhone } from "../../utils/helper";

const CreateController = ({ callBack = () => {}, id, role = null }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const params = useParams();
  const modalKey = "users";
  const title =
    role && findObjectKeyByValue(role, USER_ROLES)
      ? findObjectKeyByValue(role, USER_ROLES)
      : "User ";
  const createApi = addUserApi;
  const updateApi = updateUserField;
  const getByIdApi = getUserByIdApi;
  const { user } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const isRolePredefined = role !== null;
  const [fields, setFields] = useState({
    err: "",
    id,
    name: "",
    email: "",
    password: "",
    role: user.data.role == USER_ROLES.INSTITUTE ? USER_ROLES.FIELD_TEAM : role,
  });
  const [originalDocument, setOriginalDocument] = useState({});

  const validationSchemaForCreate = useMemo(
    () => [
      {
        required: true,
        value: fields.name,
        field: "Name",
      },
      {
        required: true,
        value: fields.email,
        field: "Email",
        isEmail: true,
      },

      {
        required: true,
        value: fields.password,
        field: "Password",
      },

      {
        required: true,
        value: fields.role,
        field: "Role",
      },

      {
        required: true,
        value: fields.phone,

        field: "Phone No. ",
        custom: () => {
          if (!validatePhone(fields.phone)) {
            return "Phone No is invalid.";
          }
          return true;
        },
      },
      {
        value: fields.country,
        field: "Country",
        // required:true,
        // custom: () => {
        //     const roles = [
        //         USER_ROLES.TEACHER,

        //         USER_ROLES.GOVERMENT,
        //     ]
        //     if (roles.includes(fields.role) && (!fields.country || fields.country == '')) {
        //         return "Country is required."
        //     }
        //     return true
        // }
      },

      {
        value: fields.state,
        field: "State",
        // required:true
        // custom: () => {
        //     const roles = [
        //         USER_ROLES.TEACHER,

        //         USER_ROLES.GOVERMENT,
        //     ]
        //     if (roles.includes(fields.role) && (!fields.state || fields.state == '')) {
        //         return "State is required."
        //     }
        //     return true
        // }
      },
      {
        value: fields.district,
        field: "District",
        // required:true
        // custom: () => {
        //     const roles = [
        //         USER_ROLES.TEACHER,

        //     ]
        //     if (roles.includes(fields.role) && (!fields.district || fields.district == '')) {
        //         return "District is required."
        //     }
        //     return true
        // }
      },

      {
        value: fields.taluka,
        field: "Taluka",

        // custom: () => {
        //     const roles = [
        //         USER_ROLES.TEACHER
        //     ]

        //     if (roles.includes(fields.role) && (!fields.taluka || fields.taluka == '')) {

        //         return "Taluka is required."
        //     }
        //     console.log("in")
        //     return true
        // }
      },
    ],
    [fields],
  );

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.name,
        field: "Name",
      },
      {
        value: fields.phone,
        field: "Phone",
        required: true,
      },
    ],
    [fields],
  );

  const createFunction = async () => {
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await createApi(fields),
          async (response) => {
            await callBack(response);
            setLoading(false);
            dispatch(closeModal(modalKey));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          },
        ),
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const updateFunction = async () => {
    const validationResponse = validate(validationSchemaForUpdate);
    let updatedData = { id };

    for (let field in fields) {
      if (
        originalDocument[field] &&
        fields[field] &&
        fields[field] != originalDocument[field]
      ) {
        updatedData[field] = fields[field];
      }

      if (!originalDocument[field] && fields[field]) {
        updatedData[field] = fields[field];
      }
    }

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await updateApi(updatedData),
          async (response) => {
            await callBack(response, updatedData);
            setLoading(false);
            dispatch(closeModal(modalKey));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          },
        ),
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (id) updateFunction();
    else createFunction();
  };

  const fetchById = (id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getByIdApi({ id }),
        async (response) => {
          setFields({ ...fields, ...response });
          setOriginalDocument(response);
          setLoading(false);
        },
        (err) => {
          setFields({ ...fields, err });
          setLoading(false);
        },
      ),
    );
  };

  useEffect(() => {
    if (id) fetchById(id);
  }, [id]);

  return (
    <CreateUi
      isRolePredefined={isRolePredefined}
      modalKey={modalKey}
      title={title}
      isUpdate={id}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
    />
  );
};
export default memo(CreateController);
